/**
 * The App Runner API returns 500 for GET /movies/list/{slug} with MDBList-style
 * filter_imdbrating_min / filter_tomatorating_min (see getMoviesWithRatingFilters).
 * Discover GET /movies and /tv with imdb_rating / rt_rating returns 200 instead.
 */
export function hasRatingSliderFilters(filters) {
  return (filters.imdbRating ?? 0) > 0 || (filters.rottenTomatoesRating ?? 0) > 0;
}
